var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriversLicense(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 49,
    viewBox: "0 0 49 49",
    width: 49,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#444"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m39.3 12.9h-29.6a2.7 2.7 0 0 0 -2.7 2.7v17.6a2.7 2.7 0 0 0 2.7 2.7h29.6a2.7 2.7 0 0 0 2.7-2.7v-17.6a2.7 2.7 0 0 0 -2.7-2.7zm-.3 20h-29v-17h29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.935 26.7h2.797v-1.632h-3.263z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.269 26.7h2.797l.466-1.632h-3.263z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.009 24.185v6.815h2.991v-1h10v1h2.992v-6.815l-.94-1.035h.948v-1.5h-2.087l-1.335-2.65h-9.155l-1.336 2.65h-2.087v1.5h.948zm4.645-3.185h6.693l.73 1.45h-8.177zm-2.645 5h2.379l-.35-1.065-1.758-.276.644-.659h10.181l.623.658-1.766.277-.349 1.065h2.379v2h-11.983z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 20h7v2h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 23h7v2h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 26h7v2h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 29h7v2h-7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriversLicense);
export default __webpack_public_path__ + "static/media/drivers-license.2d8bc1f70d7f504457fd684f7c2091e1.svg";
export { ForwardRef as ReactComponent };